import { AdjustmentType } from '@frontend/pricing-search';
import { getBuySideQualification } from '../../common/Qualification/QualificationActions';
import { getRateSelector } from '../lockSummary/actionCreators';

export const getUpdatedSummary = async (selectedPrice, loanData, dispatch) => {
  const newLoanData =
    selectedPrice !== 'currentPrice'
      ? loanData
      : {
          ...loanData,
          relockRequest: {
            ...loanData?.relockRequest,
            effectiveDate: '',
          },
        };
  const pricing = await getBuySideQualification('', newLoanData, dispatch);
  return getRateSelector(
    dispatch,
    newLoanData,
    undefined,
    undefined,
    pricing?.loanPrograms,
  );
};

export const mapTempApprovedReasonToApprovedReason = (adjustments) => {
  return adjustments.map((adjustment) => {
    if (
      adjustment.adjustmentType === AdjustmentType.BranchPriceConcession ||
      adjustment.adjustmentType === AdjustmentType.CorporatePriceConcession
    ) {
      const { tempApprovedReason, ...rest } = adjustment;
      return {
        ...rest,
        approvedReason: tempApprovedReason ?? adjustment?.approvedReason,
      };
    }
    return adjustment;
  });
};
